/* global jQuery COMPONENTS */

COMPONENTS.ComponentContact = (function ($) {
  function ComponentContact () {
    this.$component = $('[data-ecs-component-container="component-contact"]')
    this.$messageAnchor = this.$component.find('[name="thank-you-message"]')
  }

  ComponentContact.prototype.init = function () {
    const component = this

    $(document).on('scf_submit_success', function () {
      if (component.$messageAnchor.length >= 1) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(component.$messageAnchor).offset().top
        }, 1000)
      }
    })
  }

  return ComponentContact
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentContact = new COMPONENTS.ComponentContact()
  COMPONENTS.ComponentContact.init()
})
